
import React, { useEffect, useState, forwardRef, useRef } from "react";

import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import {
    Box, Button, Grid, Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import HomeIcon from '@mui/icons-material/Home';
import styles from '../../../styles.module.css';
import DCForSaleList from "../deliveryChallan/DCForSaleList";
import SalesInvoiceList from "../salesInvoice/SalesInvoiceList";
import CustomerList from "../customer/CustomerList";
import QuotationList from "../quotation/QuotationList";
import SalesDashboard from "./SalesDashboard";
import Customer_Supplier_PaymentListTab from "../../payments/Customer_Supplier_PaymentListTab";
import SalesOrderList from "../salesOrder/SalesOrderList";
import { NavLink, useLocation } from "react-router-dom";
import Breadcrumb from "../../reusableComponent/Breadcrumb";

const CustomTab = styled(Tab)(({ theme }) => ({
    // marginTop:'10px',
    minWidth: '9px',
    minHeight: '8px',
    marginRight: '6px',
    fontWeight: '400',
    fontSize: '13px',
    color: '#000000',
    borderRadius: '6px 6px 0px 0px',
    border: '1px solid #e6e8eb',
    backgroundColor: '#ffffff',
    padding: '4px 6px 4px 6px',
    margin: '1px 1px 1px 1px',
    letterSpacing: '0.3px',
    wordSpacing: '0.8px',
    textTransform: 'none',
    // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function SalesHome() {
    const location = useLocation();
    const backBtnTab = location.state?.backBtnTab || 0;
    const [selectedTab, setSelectedTab] = useState(backBtnTab);

    const [previousTabs, setPreviousTabs] = useState([]);

    console.log("backBtnTab ", backBtnTab)
    
    const handleChangeTab = (event, newValue) => {
        setPreviousTabs((prev) => [...prev, selectedTab]);
        setSelectedTab(newValue);
    };

    const handlePreviousTab = () => {
        if (previousTabs.length > 0) {
            const previousTab = previousTabs.pop();
            setSelectedTab(previousTab);
            setPreviousTabs([...previousTabs]);
        }
    };

    return (
        <>
            {/* <Paper className={`${styles.list_container}`}>
                <Box sx={{ width: '100%', padding: '4px', paddingTop: '4px' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', maxHeight: '28px', marginLeft: '11px' }}>
                        <Tabs value={selectedTab} onChange={handleChangeTab} aria-label="basic tabs example"
                            indicatorColor="none"
                            textColor="#FFFFFF"
                   
                            sx={{}}
                            variant="scrollable" >
                            <CustomTab label="Sales Home" {...a11yProps(0)} style={selectedTab === 0 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                            <CustomTab label="Customer" {...a11yProps(1)} style={selectedTab === 1 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                            <CustomTab label="Quotation" {...a11yProps(2)} style={selectedTab === 2 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                            <CustomTab label="Delivery Challan" {...a11yProps(3)} style={selectedTab === 3 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                            <CustomTab label="Sales Order" {...a11yProps(4)} style={selectedTab === 4 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                            <CustomTab label="Sales Invoice" {...a11yProps(5)} style={selectedTab === 5 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                            <CustomTab label="Customer Payment" {...a11yProps(6)} style={selectedTab === 6 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                        </Tabs>
                    </Box>
                    <TabPanel value={selectedTab} index={0}>
                        <SalesDashboard />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1}>
                        <CustomerList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} currentTab={selectedTab} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={2}>
                        <QuotationList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} currentTab={selectedTab} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={3} >
                        <DCForSaleList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} currentTab={selectedTab} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={4}>
                        <SalesOrderList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} currentTab={selectedTab} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={5}>
                        <SalesInvoiceList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} currentTab={selectedTab} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={6}>
                        <Customer_Supplier_PaymentListTab handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} currentTab={selectedTab} />
                    </TabPanel>
                </Box>
            </Paper> */}

            <Paper style={{ borderRadius: '0px' }}>
                <Box
                    sx={{ overflow: 'auto', whiteSpace: 'nowrap', margin: '10px 10px 20px 10px' }} >
                    {(location.pathname == '/sales/') ?
                        <NavLink to='/sales/'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Sales Home</Button>
                        </NavLink>
                        :
                        <NavLink to='/sales/'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Sales Home</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/sales/customer') ?
                        <NavLink to='/sales/customer'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Customer</Button>
                        </NavLink>
                        :
                        <NavLink to='/sales/customer'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }} >Customer</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/sales/quotaion') ?
                        <NavLink to='/sales/quotaion'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Quotation</Button>
                        </NavLink>
                        :
                        <NavLink to='/sales/quotaion'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Quotation</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/sales/delivery-challan') ?
                        <NavLink to='/sales/delivery-challan'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Delivery Challan</Button>
                        </NavLink>
                        :
                        <NavLink to='/sales/delivery-challan'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }} >Delivery Challan</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/sales/sales-order') ?
                        <NavLink to='/sales/sales-order'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Sales Order</Button>
                        </NavLink>
                        :
                        <NavLink to='/sales/sales-order'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }} >Sales Order</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/sales/proforma-invoice') ?
                        <NavLink to='/sales/proforma-invoice'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Proforma Invoice</Button>
                        </NavLink>
                        :
                        <NavLink to='/sales/proforma-invoice'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }} >Proforma Invoice</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/sales/sales-invoice') ?
                        <NavLink to='/sales/sales-invoice'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Sales Invoice</Button>
                        </NavLink>
                        :
                        <NavLink to='/sales/sales-invoice'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }} >Sales Invoice</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/sales/customer-payment') ?
                        <NavLink to='/sales/customer-payment'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Customer Payment</Button>
                        </NavLink>
                        :
                        <NavLink to='/sales/customer-payment'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }} >Customer Payment</Button>
                        </NavLink>
                    }
                </Box>
            </Paper>
        </>
    )
}

export default SalesHome;